import Marionette from 'marionette';
import template from './template.html';

const MembershipsListView = Marionette.ItemView.extend({
	template: template
});

export default MembershipsListView;
